import "./trainerPortal.css";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AxiosInstance from "../Home/AxiosInstance";

const TrainerCourseMaterial = () => {
  const [profileId, setProfileId] = useState("");
  const [course, setCourse] = useState("");
  const [subTopics, setSubTopics] = useState("");
  const [description, setDescription] = useState("");
  const [courseOptions, setCourseOptions] = useState([]);
  const [profiles, setProfiles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [newCourseName, setNewCourseName] = useState("");
  const [newCourseLogo, setNewCourseLogo] = useState("");

  const navigate = useNavigate();
  const trainerId = localStorage.getItem("trainerId");

  useEffect(() => {
    if (!trainerId) {
      alert("Trainer ID not found. Please log in.");
      return;
    }

    const fetchData = async () => {
      try {
        const [profileRes, courseRes] = await Promise.all([
          AxiosInstance.get(`companies/trainer/profile/${trainerId}/`),
          AxiosInstance.get("companies/courses/"),
        ]);
        setProfiles(profileRes.data);
        setCourseOptions(courseRes.data);
      } catch (error) {
        console.error(error);
        alert("Error fetching profiles or courses.");
      }
    };

    fetchData();
  }, [trainerId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    if (!trainerId || !profileId || !subTopics || !description || (!course && !newCourseName)) {
      alert("All fields are required.");
      setIsLoading(false);
      return;
    }

    let courseId = course;

    // If 'Other' is selected, create the new course first
    if (course === "other") {
      if (!newCourseName || !newCourseLogo) {
        alert("Please provide both course name and logo.");
        setIsLoading(false);
        return;
      }

      try {
        const formData = new FormData();
        formData.append("course_name", newCourseName);
        formData.append("course_logo", newCourseLogo);

        const courseResponse = await AxiosInstance.post(
          "companies/course/",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (courseResponse.status === 201) {
          courseId = courseResponse.data.course_id;
          alert("New course created successfully.");
        } else {
          throw new Error("Failed to create course.");
        }
      } catch (error) {
        console.error("Course creation failed:", error);
        alert("Error creating new course.");
        setIsLoading(false);
        return;
      }
    }

    const newCourseMaterial = {
      trainer: parseInt(trainerId),
      profile: parseInt(profileId),
      course: parseInt(courseId),
      sub_topics: subTopics,
      description,
    };

    try {
      const response = await AxiosInstance.post(
        "companies/user/course/materials/",
        newCourseMaterial
      );

      if (response.status === 201) {
        alert("Course material added successfully!");
        navigate(-1);
      } else {
        alert("Failed to add course material.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("An error occurred while saving course material.");
    } finally {
      setIsLoading(false);
    }
  };

  const closeModal = () => navigate(-1);

  return (
    <>
      <div className="modal-backdrop fade show"></div>

      <div
        className="modal d-block als-trainer-portal"
        tabIndex="-1"
        aria-modal="true"
        role="dialog"
        style={{ backgroundColor: "rgba(11,14,39,0.45)" }}
      >
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content">

            <div className="modal-header">
              <h5 className="modal-title">Add Course Material</h5>
            </div>

            <div className="modal-body">
              <form onSubmit={handleSubmit}>
                {/* Profile */}
                <div className="mb-3">
                  <label className="form-label">Profile:</label>
                  <select
                    className="form-select"
                    value={profileId}
                    onChange={(e) => setProfileId(e.target.value)}
                    required
                    disabled={isLoading}
                  >
                    <option value="">Select Profile</option>
                    {profiles.map((profile) => (
                      <option key={profile.profile_id} value={profile.profile_id}>
                        {profile.profile_name}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Course */}
                <div className="mb-3">
                  <label className="form-label">Course:</label>
                  <select
                    className="form-select"
                    value={course}
                    onChange={(e) => setCourse(e.target.value)}
                    required
                    disabled={isLoading}
                  >
                    <option value="">Select Course</option>
                    {courseOptions.map((c) => (
                      <option key={c.course_id} value={c.course_id}>
                        {c.course_name}
                      </option>
                    ))}
                    <option value="other">Other</option>
                  </select>
                </div>

                {/* If 'Other' selected, show fields to add new course */}
                {course === "other" && (
                  <>
                    <div className="mb-3">
                      <label className="form-label">New Course Name:</label>
                      <input
                        type="text"
                        className="form-control"
                        value={newCourseName}
                        onChange={(e) => setNewCourseName(e.target.value)}
                        required
                        disabled={isLoading}
                      />
                    </div>
                    <div className="mb-3">
  <label className="form-label">New Course Logo:</label>
  <input
    type="file"
    className="form-control"
    accept="image/*"
    onChange={(e) => setNewCourseLogo(e.target.files[0])}
    required
    disabled={isLoading}
  />
</div>

                  </>
                )}

                {/* Sub Topics */}
                <div className="mb-3">
                  <label className="form-label">Sub Topics:</label>
                  <input
                    type="text"
                    className="form-control"
                    value={subTopics}
                    onChange={(e) => setSubTopics(e.target.value)}
                    required
                    disabled={isLoading}
                  />
                </div>

                {/* Description */}
                <div className="mb-3">
                  <label className="form-label">Description:</label>
                  <textarea
                    className="form-control"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    rows="4"
                    required
                    disabled={isLoading}
                  />
                </div>

                <div className="d-flex justify-content-end">
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    onClick={closeModal}
                    disabled={isLoading}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={isLoading}
                  >
                    {isLoading ? "Saving..." : "Save Course Material"}
                  </button>
                </div>
              </form>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default TrainerCourseMaterial;
